module.exports = __webpack_public_path__ + "img/Logo_MB_primary.png";